"use client";

import { useEffect, useRef, useState } from "react";
import "./CommonHeading.css";

const CommonHeading = ({ subTitle, title, description, center = false }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true); // Enter viewport
        } else {
          setVisible(false); // Leave viewport
        }
      },
      {
        threshold: 0.3,
      },
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`common_heading ${center ? "text-center" : ""} ${
        visible ? "show" : ""
      }`}
    >
      <h5>{subTitle}</h5>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </div>
  );
};

export default CommonHeading;
